<div *ngIf="isResRepEH else pageNotFound"> 
    <wackadoo-repository-page></wackadoo-repository-page>
</div>
<ng-template #pageNotFound>
    <wackadoo-page-not-found></wackadoo-page-not-found>
</ng-template>
